import React from 'react';
import {
    commitmentStatement,
    courseStatement,
} from '@/shared/utils/requirementAnswers';

/**
 * A student's answers about the positions they chose, read only: whether they
 * completed the position's course (or its equivalent), and the confirmation
 * that they can attend its meeting times and the required training, and
 * commit its hours a week. The server decides which answers a reader is sent (a reviewer gets the answers
 * for the position being reviewed). `courseLabel` names the position's
 * course, "MTH 1410", when the reader knows it; `labelFor(entry)` names each
 * course answer's course when one list carries the answers of several
 * positions. `only` limits the list to one rule ('priorCompletion' or
 * 'positionCommitment'). `own` words the commitment for the student reading
 * their own answers. The student asserts these; nothing here is a grade or a
 * GPA.
 */
export default function RequirementAnswersSummary({
    answers,
    courseLabel = 'this course',
    labelFor,
    only,
    own = false,
}) {
    const list = (answers || []).filter(
        (entry) => entry.rule !== 'minimumGPA' && (!only || entry.rule === only)
    );
    if (list.length === 0) return null;
    return (
        <ul className="list-unstyled mb-0">
            {list.map((entry) => {
                const key = `${entry.rule}-${entry.position || ''}`;
                if (entry.rule === 'positionCommitment') {
                    const statement = commitmentStatement(entry.minimum);
                    const named = labelFor ? ` for ${labelFor(entry)}` : '';
                    return (
                        <li key={key}>
                            {own
                                ? statement.replace('they can', 'you can')
                                : statement}
                            {named}
                        </li>
                    );
                }
                return (
                    <li key={key}>
                        {courseStatement(
                            labelFor ? labelFor(entry) : courseLabel
                        )}
                        : <strong>{entry.met ? 'Yes' : 'No'}</strong>
                        {!entry.met && (
                            <span className="text-body-secondary">
                                {' '}
                                (self-reported)
                            </span>
                        )}
                    </li>
                );
            })}
        </ul>
    );
}
